import React, { useState, useRef, useCallback, useEffect, useMemo } from "react";
import { connect } from "react-redux";
import { useHistory } from 'react-router-dom';
import { LoadPanel } from 'devextreme-react/load-panel';
import Toolbar, { Item } from "devextreme-react/toolbar";
import { Button, ScrollView } from 'devextreme-react';
import { alert, confirm } from 'devextreme/ui/dialog';
import axios from "axios";
import FormField from '../../../../../../dynamicFormBuilder/FormField';
import { GetFormatedDateWithTime } from '../../../../../../common/Utils';
import { WMTransactionDPLookupLayout, WMCodesLookupLayout } from '../../../../../../common/lookups/Layouts/WMLayouts';
import { TransactionStageEnum, TransactionStatus, UserDefinedCodeFields, TransactionStageDescriptions, TransactionStatusDescriptions } from '../../../../../../enum/Enum';
import data from '../../../../../../assets/apiRoutes.json';
import {
    IDConsigneeLookupLayout,
    IDShipperLookupLayout,
} from "../../../../../../common/lookups/Layouts/IdLayouts"
import {
    ACDepartmentLayout,
} from "../../../../../../common/lookups/Layouts/ACLayouts"
import {
    FAFundLayout,
} from "../../../../../../common/lookups/Layouts/FALayouts"
import {
    CAJobLayout,
} from "../../../../../../common/lookups/Layouts/CALayouts"
const RepackShipmentLayout = [
    {
        "groupId": 1,
        "label": "",
        "fields": [
            {
                "name": "R_PROFILE",
                "tableName": "WMSETUP",
                "label": "Profile",
                "type": "lookup",
                "layout": WMTransactionDPLookupLayout,
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "STAGE",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "Stage",
                "type": "select",
                "options": [],
                "apiUrl": null,
                "grid": null,
                "required": true,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "STATUS",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "Status",
                "type": "select",
                "options": [],
                "apiUrl": null,
                "grid": null,
                "required": true,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "HOLDREASON",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "Hold Reason",
                "type": "lookup",
                layout: WMCodesLookupLayout({ codeType: '34' }),
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "TRANSACTIONDATE",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "Trans Date",
                "type": "date",
                "options": null,
                "apiUrl": null,
                "grid": null,
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "ACTUALRECEIVEDSHIPPEDDATETIME",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "Recv/Ship Dt",
                "type": "date",
                "options": null,
                "apiUrl": null,
                "grid": null,
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "R_SHIPPER",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "Shipper",
                "type": "lookup",
                "layout": IDShipperLookupLayout({ valueExpr: 'id', displayExpr: 'identityid' }),
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "R_CONSIGNEE",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "Consignee",
                "type": "lookup",
                "layout": IDConsigneeLookupLayout({ valueExpr: 'id', displayExpr: 'identityid' }),
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "SHIPPERBOLNUMBER",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "Shipper #",
                "type": "text",
                "options": null,
                "apiUrl": null,
                "grid": null,
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "REFERENCE",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "PO/Reference",
                "type": "text",
                "options": null,
                "apiUrl": null,
                "grid": null,
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }
        ]
    },
    {
        "groupId": 2,
        "label": "Accounting",
        "fields": [
            {
                "name": "R_GLDEPARTMENT",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "Department",
                "type": "lookup",
                "layout": ACDepartmentLayout,
                "required": false,
                "visible": true,
                "isLabelChanged": true,
            },
            {
                "name": "R_GLFUND",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "FA Fund",
                "type": "lookup",
                "layout": FAFundLayout,
                "required": false,
                "visible": true,
                "isLabelChanged": true,
            },
            {
                "name": "R_CAJOB",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "CA Job",
                "type": "lookup",
                "layout": CAJobLayout,
                "required": false,
                "visible": true,
                "isLabelChanged": true,
            }
        ]
    },
    {
        "groupId": 3,
        "label": "User Defined",
        "fields": [
            {
                "name": UserDefinedCodeFields.Code1,
                "tableName": "WMTRANSACTIONHEADER",
                "label": "Code - 1",
                "type": "lookup",
                layout: WMCodesLookupLayout({ codeType: '03' }),
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": UserDefinedCodeFields.Code2,
                "tableName": "WMTRANSACTIONHEADER",
                "label": "Code - 2",
                "type": "lookup",
                layout: WMCodesLookupLayout({ codeType: '04' }),
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": UserDefinedCodeFields.Code3,
                "tableName": "WMTRANSACTIONHEADER",
                "label": "Code - 3",
                "type": "lookup",
                layout: WMCodesLookupLayout({ codeType: '05' }),
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": UserDefinedCodeFields.Code4,
                "tableName": "WMTRANSACTIONHEADER",
                "label": "Code - 4",
                "type": "lookup",
                layout: WMCodesLookupLayout({ codeType: '06' }),
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": UserDefinedCodeFields.Code5,
                "tableName": "WMTRANSACTIONHEADER",
                "label": "Code - 5",
                "type": "lookup",
                layout: WMCodesLookupLayout({ codeType: '07' }),
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDDATE1",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "Date - 1",
                "type": "date",
                "options": null,
                "apiUrl": null,
                "grid": null,
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDDATE2",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "Date - 2",
                "type": "date",
                "options": null,
                "apiUrl": null,
                "grid": null,
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDDATE3",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "Date - 3",
                "type": "date",
                "options": null,
                "apiUrl": null,
                "grid": null,
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDDATE4",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "Date - 4",
                "type": "date",
                "options": null,
                "apiUrl": null,
                "grid": null,
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDDATE5",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "Date - 5",
                "type": "date",
                "options": null,
                "apiUrl": null,
                "grid": null,
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDQUANTITY1",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "Quantity - 1",
                "type": "number",
                "options": null,
                "apiUrl": null,
                "grid": null,
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDQUANTITY2",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "Quantity - 2",
                "type": "number",
                "options": null,
                "apiUrl": null,
                "grid": null,
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDQUANTITY3",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "Quantity - 3",
                "type": "number",
                "options": null,
                "apiUrl": null,
                "grid": null,
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDQUANTITY4",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "Quantity - 4",
                "type": "number",
                "options": null,
                "apiUrl": null,
                "grid": null,
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDREFERENCE1",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "Reference - 1",
                "type": "text",
                "options": null,
                "apiUrl": null,
                "grid": null,
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDREFERENCE2",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "Reference - 2",
                "type": "text",
                "options": null,
                "apiUrl": null,
                "grid": null,
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDREFERENCE3",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "Reference - 3",
                "type": "text",
                "options": null,
                "apiUrl": null,
                "grid": null,
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDREFERENCE4",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "Reference - 4",
                "type": "text",
                "options": null,
                "apiUrl": null,
                "grid": null,
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDREFERENCE5",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "Reference - 5",
                "type": "text",
                "options": null,
                "apiUrl": null,
                "grid": null,
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }
        ]
    },
    {
        "groupId": 4,
        "label": "Repack Shipment Record",
        "fields": [
            {
                "name": "TRANSACTIONNUMBER",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "Transaction #",
                "type": "text",
                "options": null,
                "apiUrl": null,
                "grid": null,
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "REPACKSHIPMENTRECORD",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "",
                "type": "text",
                "options": null,
                "apiUrl": null,
                "grid": null,
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }
        ]
    }
];

const initialFormFields = {
    R_PROFILE: null,
    STAGE: "R",
    STATUS: "O",
    HOLDREASON: null,
    TRANSACTIONDATE: new Date(),
    ACTUALRECEIVEDSHIPPEDDATETIME: new Date(),
    R_SHIPPER: null,
    R_CONSIGNEE: null,
    SHIPPERBOLNUMBER: "",
    REFERENCE: "",
    R_GLDEPARTMENT: null,
    R_GLFUND: null,
    R_CAJOB: null,
    [UserDefinedCodeFields.Code1]: null,
    [UserDefinedCodeFields.Code2]: null,
    [UserDefinedCodeFields.Code3]: null,
    [UserDefinedCodeFields.Code4]: null,
    [UserDefinedCodeFields.Code5]: null,
    USERDEFINEDDATE1: null,
    USERDEFINEDDATE2: null,
    USERDEFINEDDATE3: null,
    USERDEFINEDDATE4: null,
    USERDEFINEDDATE5: null,
    USERDEFINEDQUANTITY1: null,
    USERDEFINEDQUANTITY2: null,
    USERDEFINEDQUANTITY3: null,
    USERDEFINEDQUANTITY4: null,
    USERDEFINEDREFERENCE1: "",
    USERDEFINEDREFERENCE2: "",
    USERDEFINEDREFERENCE3: "",
    USERDEFINEDREFERENCE4: "",
    USERDEFINEDREFERENCE5: "",
    TRANSACTIONNUMBER: "",
    REPACKSHIPMENTRECORD: ""
};

// Stage options using TransactionStageEnum and TransactionStageDescriptions constants
const stages = [
    { Rowid: TransactionStageEnum.Plan, Code: TransactionStageDescriptions.Plan },
    { Rowid: TransactionStageEnum.FutureOrder, Code: TransactionStageDescriptions.FutureOrder },
    { Rowid: TransactionStageEnum.Pending, Code: TransactionStageDescriptions.Pending },
    { Rowid: TransactionStageEnum.ReadyToReceivePickStaged, Code: TransactionStageDescriptions.ReadyToReceivePickStaged },
    { Rowid: TransactionStageEnum.Completed, Code: TransactionStageDescriptions.Completed }
];

// Status options using TransactionStatus and TransactionStatusDescriptions constants
const statuses = [
    { Rowid: TransactionStatus.Open, Code: TransactionStatusDescriptions.Open },
    { Rowid: TransactionStatus.Hold, Code: TransactionStatusDescriptions.Hold },
    { Rowid: TransactionStatus.ReadyToCommitLater, Code: TransactionStatusDescriptions.ReadyToCommitLater },
    { Rowid: TransactionStatus.Committed, Code: TransactionStatusDescriptions.Committed }
];

function CreateRepackShipments(props) {
    let accessToken = props.oidc.user.access_token;
    const history = useHistory();
    const position = { of: '#accordion-containe2' };
    const [loadPanelVisible, setLoadPanelVisible] = useState(false);
    const [isFormSubmitted, setIsFormSubmitted] = useState(false);
    const DYNAMICFORMSETTING = props.oidc?.user?.profile?.DYNAMICFORMSETTING;
    const formRefs = useRef({});
    var currentUser = props.oidc.user;

    const [formFields, setformFields] = useState(initialFormFields);
    const [createdTransactionRowId, setCreatedTransactionRowId] = useState(null);

    const hideLoadPanel = useCallback(() => {
        setLoadPanelVisible(false);
    }, []);

    const handleFieldChange = useCallback((name, value, e) => {
        setformFields(prevFields => ({
            ...prevFields,
            [name]: value
        }));

        // Enable/disable HOLDREASON based on STATUS
        if (name === "STATUS") {
            if (value === TransactionStatus.Hold) {
                // Enable HOLDREASON when STATUS is Hold
                if (formRefs.current["HOLDREASON"]) {
                    const ref = formRefs.current["HOLDREASON"];
                    if (typeof ref.instance === 'function') {
                        const instance = ref.instance();
                        if (instance && typeof instance.option === 'function') {
                            instance.option('disabled', false);
                        }
                    }
                }
            } else {
                // Disable HOLDREASON and clear value when STATUS is not Hold
                if (formRefs.current["HOLDREASON"]) {
                    const ref = formRefs.current["HOLDREASON"];
                    if (typeof ref.instance === 'function') {
                        const instance = ref.instance();
                        if (instance && typeof instance.option === 'function') {
                            instance.option('disabled', true);
                        }
                    }
                }
                // Clear HOLDREASON value
                setformFields(prevFields => ({
                    ...prevFields,
                    HOLDREASON: null
                }));
            }
        }
    }, []);

    const handleFormSubmit = async (e) => {
        if (e && e.preventDefault) {
            e.preventDefault();
        }

        // Validation
        if (!formFields.R_PROFILE) {
            alert("Profile is required.", "Validation Error");
            setIsFormSubmitted(false);
            return;
        }

        setLoadPanelVisible(true);
        setIsFormSubmitted(true);
        try {
            const requestData = {
                TransactionHeaderRowId: props.TransactionHeaderRowId,
                R_Customer: null, // Will be set from receipt transaction
                R_Profile: formFields.R_PROFILE,
                R_Shipper: formFields.R_SHIPPER,
                R_Consignee: formFields.R_CONSIGNEE,
                R_GLDepartment: formFields.R_GLDEPARTMENT,
                R_FAFund: formFields.R_GLFUND,
                R_CAJob: formFields.R_CAJOB,
                Shipper: formFields.SHIPPERBOLNUMBER || "",
                Reference: formFields.REFERENCE || "",
                Stage: formFields.STAGE || "R",
                Status: formFields.STATUS || "O",
                HoldReason: formFields.HOLDREASON || "",
                UserDefinedCode_1: formFields[UserDefinedCodeFields.Code1] || "",
                UserDefinedCode_2: formFields[UserDefinedCodeFields.Code2] || "",
                UserDefinedCode_3: formFields[UserDefinedCodeFields.Code3] || "",
                UserDefinedCode_4: formFields[UserDefinedCodeFields.Code4] || "",
                UserDefinedCode_5: formFields[UserDefinedCodeFields.Code5] || "",
                UserDefinedDate_1: formFields.USERDEFINEDDATE1 ? GetFormatedDateWithTime(formFields.USERDEFINEDDATE1) : null,
                UserDefinedDate_2: formFields.USERDEFINEDDATE2 ? GetFormatedDateWithTime(formFields.USERDEFINEDDATE2) : null,
                UserDefinedDate_3: formFields.USERDEFINEDDATE3 ? GetFormatedDateWithTime(formFields.USERDEFINEDDATE3) : null,
                UserDefinedDate_4: formFields.USERDEFINEDDATE4 ? GetFormatedDateWithTime(formFields.USERDEFINEDDATE4) : null,
                UserDefinedDate_5: formFields.USERDEFINEDDATE5 ? GetFormatedDateWithTime(formFields.USERDEFINEDDATE5) : null,
                UserDefinedQuantity_1: formFields.USERDEFINEDQUANTITY1 || null,
                UserDefinedQuantity_2: formFields.USERDEFINEDQUANTITY2 || null,
                UserDefinedQuantity_3: formFields.USERDEFINEDQUANTITY3 || null,
                UserDefinedQuantity_4: formFields.USERDEFINEDQUANTITY4 || null,
                UserDefinedReference_1: formFields.USERDEFINEDREFERENCE1 || "",
                UserDefinedReference_2: formFields.USERDEFINEDREFERENCE2 || "",
                UserDefinedReference_3: formFields.USERDEFINEDREFERENCE3 || "",
                UserDefinedReference_4: formFields.USERDEFINEDREFERENCE4 || "",
                UserDefinedReference_5: formFields.USERDEFINEDREFERENCE5 || "",
                ActualRecShipDate: formFields.ACTUALRECEIVEDSHIPPEDDATETIME ? GetFormatedDateWithTime(formFields.ACTUALRECEIVEDSHIPPEDDATETIME) : null
            };

            const response = await axios.post(
                `${window._env_.REACT_APP_APIS}/wm/TransactionHeaderOperations/CreateRepackShipment`,
                requestData,
                {
                    headers: {
                        'Content-Type': 'application/json',
                        access_token: accessToken,
                        Authorization: `Bearer ${accessToken}`
                    }
                }
            );

            if (response.data && response.data.success) {
                // Store the created transaction row ID and update transaction number field
                const responseData = response.data.data;
                if (responseData) {
                    setCreatedTransactionRowId(responseData.headerRowId || responseData.HeaderRowId);
                    
                    // Update formFields state first
                    if (responseData.newTNumber || responseData.NewTNumber) {
                        const transactionNumber = responseData.newTNumber || responseData.NewTNumber;
                        const detailCount = responseData.detailRecordsCount || responseData.DetailRecordsCount || 0;
                        const recordMessage = detailCount > 0 
                            ? `${detailCount} Item Detail Record${detailCount > 1 ? 's' : ''} Processed Successfully`
                            : '';
                        
                        setformFields(prevFields => ({
                            ...prevFields,
                            TRANSACTIONNUMBER: transactionNumber,
                            REPACKSHIPMENTRECORD: recordMessage
                        }));
                        
                        // Update the field refs after a short delay to ensure form is rendered
                        setTimeout(() => {
                            // Update TRANSACTIONNUMBER field
                            if (formRefs.current["TRANSACTIONNUMBER"]) {
                                const ref = formRefs.current["TRANSACTIONNUMBER"];
                                if (typeof ref.instance === 'function') {
                                    const instance = ref.instance();
                                    if (instance && typeof instance.option === 'function') {
                                        instance.option('disabled', false);
                                        instance.option('value', transactionNumber);
                                        instance.option('disabled', true);
                                    }
                                }
                            }
                            
                            // Update REPACKSHIPMENTRECORD field
                            if (formRefs.current["REPACKSHIPMENTRECORD"] && recordMessage) {
                                const ref = formRefs.current["REPACKSHIPMENTRECORD"];
                                if (typeof ref.instance === 'function') {
                                    const instance = ref.instance();
                                    if (instance && typeof instance.option === 'function') {
                                        instance.option('disabled', false);
                                        instance.option('value', recordMessage);
                                        instance.option('disabled', true);
                                    }
                                }
                            }
                        }, 200);
                    }
                }
                
                alert("Repack shipment created successfully.", "Success");
                setIsFormSubmitted(false);
                // Don't close popup - let user see the transaction number
                if (props.Success) {
                    props.Success();
                }
            } else if (response.data?.message === "REPACK_EXISTS") {
                // Step 1: Repack transaction already exists - show confirm dialog
                setIsFormSubmitted(false);
                const result = await confirm(
                    "Repack transaction already exists. Do you want to delete and recreate a new one?",
                    "Repack Transaction Exists"
                );
                
                if (result) {
                    // User confirmed - proceed with creating new shipment record
                    setLoadPanelVisible(true);
                    setIsFormSubmitted(true);
                    
                    try {
                        // Add DeleteExisting flag to indicate user confirmed deletion
                        const deleteAndCreateData = {
                            ...requestData,
                            DeleteExisting: true
                        };
                        
                        // Make the same API call again with DeleteExisting flag - backend will handle delete and create
                        const createResponse = await axios.post(
                            `${window._env_.REACT_APP_APIS}/wm/TransactionHeaderOperations/CreateRepackShipment`,
                            deleteAndCreateData,
                            {
                                headers: {
                                    'Content-Type': 'application/json',
                                    access_token: accessToken,
                                    Authorization: `Bearer ${accessToken}`
                                }
                            }
                        );

                        if (createResponse.data && createResponse.data.success) {
                            // Store the created transaction row ID and update transaction number field
                            const responseData = createResponse.data.data;
                            if (responseData) {
                                setCreatedTransactionRowId(responseData.headerRowId || responseData.HeaderRowId);
                                
                                // Update formFields state first
                                if (responseData.newTNumber || responseData.NewTNumber) {
                                    const transactionNumber = responseData.newTNumber || responseData.NewTNumber;
                                    const detailCount = responseData.detailRecordsCount || responseData.DetailRecordsCount || 0;
                                    const recordMessage = detailCount > 0 
                                        ? `${detailCount} Item Detail Record${detailCount > 1 ? 's' : ''} Processed Successfully`
                                        : '';
                                    
                                    setformFields(prevFields => ({
                                        ...prevFields,
                                        TRANSACTIONNUMBER: transactionNumber,
                                        REPACKSHIPMENTRECORD: recordMessage
                                    }));
                                    
                                    // Update the field refs after a short delay to ensure form is rendered
                                    setTimeout(() => {
                                        // Update TRANSACTIONNUMBER field
                                        if (formRefs.current["TRANSACTIONNUMBER"]) {
                                            const ref = formRefs.current["TRANSACTIONNUMBER"];
                                            if (typeof ref.instance === 'function') {
                                                const instance = ref.instance();
                                                if (instance && typeof instance.option === 'function') {
                                                    instance.option('disabled', false);
                                                    instance.option('value', transactionNumber);
                                                    instance.option('disabled', true);
                                                }
                                            }
                                        }
                                        
                                        // Update REPACKSHIPMENTRECORD field
                                        if (formRefs.current["REPACKSHIPMENTRECORD"] && recordMessage) {
                                            const ref = formRefs.current["REPACKSHIPMENTRECORD"];
                                            if (typeof ref.instance === 'function') {
                                                const instance = ref.instance();
                                                if (instance && typeof instance.option === 'function') {
                                                    instance.option('disabled', false);
                                                    instance.option('value', recordMessage);
                                                    instance.option('disabled', true);
                                                }
                                            }
                                        }
                                    }, 200);
                                }
                            }
                            
                            alert("Repack shipment created successfully.", "Success");
                            setIsFormSubmitted(false);
                            // Don't close popup - let user see the transaction number
                            if (props.Success) {
                                props.Success();
                            }
                        } else {
                            alert(createResponse.data?.message || "Failed to create repack shipment.", "Error");
                            setIsFormSubmitted(false);
                        }
                    } catch (error) {
                        console.error('Error creating repack shipment:', error);
                        alert(error.response?.data?.message || error.message || "An error occurred while creating repack shipment.", "Error");
                        setIsFormSubmitted(false);
                    } finally {
                        setTimeout(hideLoadPanel, 1000);
                    }
                } else {
                    // User selected "no" - don't do anything
                    setIsFormSubmitted(false);
                }
            } else {
                alert(response.data?.message || "Failed to create repack shipment.", "Error");
                setIsFormSubmitted(false);
            }
        } catch (error) {
            console.error('Error submitting form:', error);
            alert(error.response?.data?.message || error.message || "An error occurred while creating repack shipment.", "Error");
            setIsFormSubmitted(false);
        } finally {
            setTimeout(hideLoadPanel, 1000);
        }
    };

    const handleCancel = () => {
        props.ClosePopup();
    };

    const handleShowShipmentRecord = () => {
        if (createdTransactionRowId) {
            // Close the popup first
            props.ClosePopup();
            // Then navigate to edit transaction page with the created transaction row ID
            // Use setTimeout to ensure popup closes before navigation
            setTimeout(() => {
                // Use React Router navigation to avoid page refresh
                history.push(`/wm/transactiondataentry/edit-transaction?id=${createdTransactionRowId}`);
            }, 100);
        } else {
            alert("Please create a repack shipment first.", "Info");
        }
    };
    const loadLookupClient = useCallback((name, data) => {
        try {
            const newOptions = data.map(item => ({
                id: item.Rowid,
                name: item.Code
            }));
            if (formRefs && formRefs.current && formRefs.current[name]) {
                const ref = formRefs.current[name];
                if (typeof ref.instance === 'function') {
                    const instance = ref.instance();
                    if (instance && typeof instance.option === 'function') {
                        instance.option('dataSource', newOptions);
                        instance.option('valueExpr', 'id');
                        instance.option('displayExpr', 'name');
                        if (formFields[name]) {
                            instance.option('value', formFields[name]);
                        }
                    }
                }
            }
        } catch (error) {
            console.error(`Error loading lookup for ${name}:`, error);
        }
    }, [formFields]);

    const handleFormLoad = useCallback(() => {
        loadLookupClient("STAGE", stages);
        loadLookupClient("STATUS", statuses);

        // Disable HOLDREASON on form load if STATUS is not Hold
        // Also disable readonly fields in Repack Shipment Record section
        setTimeout(() => {
            if (formRefs.current["HOLDREASON"]) {
                const ref = formRefs.current["HOLDREASON"];
                if (typeof ref.instance === 'function') {
                    const instance = ref.instance();
                    if (instance && typeof instance.option === 'function') {
                        // Enable HOLDREASON only if STATUS is Hold, otherwise disable
                        const isDisabled = formFields.STATUS !== TransactionStatus.Hold;
                        instance.option('disabled', isDisabled);
                    }
                }
            }
            
            // Set readonly fields as disabled
            if (formRefs.current["TRANSACTIONNUMBER"]) {
                const ref = formRefs.current["TRANSACTIONNUMBER"];
                if (typeof ref.instance === 'function') {
                    const instance = ref.instance();
                    if (instance && typeof instance.option === 'function') {
                        instance.option('disabled', true);
                    }
                }
            }
            
            if (formRefs.current["REPACKSHIPMENTRECORD"]) {
                const ref = formRefs.current["REPACKSHIPMENTRECORD"];
                if (typeof ref.instance === 'function') {
                    const instance = ref.instance();
                    if (instance && typeof instance.option === 'function') {
                        instance.option('disabled', true);
                    }
                }
            }
        }, 100); // Small delay to ensure form fields are rendered
    }, [loadLookupClient, formFields.STATUS]);

    // Initialize default dates
    useEffect(() => {
        const today = new Date();
        const futureDate = new Date();
        futureDate.setDate(today.getDate() + 2);

        setformFields(prev => ({
            ...prev,
            TRANSACTIONDATE: today,
            ACTUALRECEIVEDSHIPPEDDATETIME: futureDate
        }));
    }, []);

    // Handle HOLDREASON enable/disable based on STATUS
    useEffect(() => {
        if (formRefs.current["HOLDREASON"]) {
            const ref = formRefs.current["HOLDREASON"];
            if (typeof ref.instance === 'function') {
                const instance = ref.instance();
                if (instance && typeof instance.option === 'function') {
                    // Enable HOLDREASON only if STATUS is Hold
                    const isDisabled = formFields.STATUS !== TransactionStatus.Hold;
                    instance.option('disabled', isDisabled);
                }
            }
        }
    }, [formFields.STATUS]);

    // Sync TRANSACTIONNUMBER field when formFields changes
    useEffect(() => {
        if (formFields.TRANSACTIONNUMBER && formRefs.current["TRANSACTIONNUMBER"]) {
            const ref = formRefs.current["TRANSACTIONNUMBER"];
            if (typeof ref.instance === 'function') {
                const instance = ref.instance();
                if (instance && typeof instance.option === 'function') {
                    // Temporarily enable to update value, then disable again
                    instance.option('disabled', false);
                    instance.option('value', formFields.TRANSACTIONNUMBER);
                    instance.option('disabled', true);
                }
            }
        }
    }, [formFields.TRANSACTIONNUMBER]);

    // Sync REPACKSHIPMENTRECORD field when formFields changes
    useEffect(() => {
        if (formFields.REPACKSHIPMENTRECORD && formRefs.current["REPACKSHIPMENTRECORD"]) {
            const ref = formRefs.current["REPACKSHIPMENTRECORD"];
            if (typeof ref.instance === 'function') {
                const instance = ref.instance();
                if (instance && typeof instance.option === 'function') {
                    // Temporarily enable to update value, then disable again
                    instance.option('disabled', false);
                    instance.option('value', formFields.REPACKSHIPMENTRECORD);
                    instance.option('disabled', true);
                }
            }
        }
    }, [formFields.REPACKSHIPMENTRECORD]);

    return (
        <div style={{ marginLeft: '-11px', padding: '10px', height: '100%', display: 'flex', flexDirection: 'column' }}>
            <div id="accordion-containe2" style={{ height: '100%', display: 'flex', flexDirection: 'column', position: 'relative' }}>
                <LoadPanel
                    shadingColor="rgba(0,0,0,0.4)"
                    position={position}
                    onHiding={hideLoadPanel}
                    visible={loadPanelVisible}
                    showIndicator={true}
                    shading={true}
                    showPane={true}
                    hideOnOutsideClick={false}
                />

                <form onSubmit={(e) => handleFormSubmit(e)} style={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
                    <Toolbar className="header" style={{ flexShrink: 0 }}>
                        <Item location="before">
                            <Button
                                text="Show Shipment Record"
                                type="default"
                                className="accordianButton"
                                onClick={handleShowShipmentRecord}
                            />
                        </Item>
                        <Item location="after">
                            <Button
                                text="Apply"
                                icon="check"
                                useSubmitBehavior={true}
                                disabled={isFormSubmitted}
                                type="default"
                                className="accordianButton"
                            />
                        </Item>
                        <Item location="after">
                            <Button
                                className="accordianButton"
                                onClick={handleCancel}
                                text="Close"
                                icon="close"
                                stylingMode="outlined"
                            />
                        </Item>
                    </Toolbar>
                     
                        <div style={{ paddingBottom: '20px' }}>
                            {/* Instructional Banner */}
                            <div style={{
                                backgroundColor: '#f0f0f0',
                                padding: '10px',
                                marginBottom: '15px',
                                borderRadius: '4px',
                                fontSize: '13px',
                                lineHeight: '1.5'
                            }}>
                                This option allows you to create a "Repack Shipment Transaction" for the current Receipt record.
                                The Item in the Receipt must have a "Kit Code" associated with it in the Item Master record.
                                You must also specify the "Shipment Profile Code" before proceeding.
                            </div>

                            <FormField
                                currrentUser={currentUser}
                                layoutId='906e4d89-2197-4cc7-a7fb-93c8dddffbfe'
                                layoutName='CreateRepackShipmentForm'
                                defaultFormSchema={RepackShipmentLayout}
                                formFields={formFields}
                                setformFields={setformFields}
                                handleFieldValueChange={handleFieldChange}
                                DYNAMICFORMSETTING={DYNAMICFORMSETTING}
                                formRefs={formRefs}
                                onFormLoad={handleFormLoad}
                            />
                        </div>
                   
                </form>
            </div>
        </div>
    );
}

function mapStateToProps(state) {
    return {
        ReceiptReducer: state.ReceiptReducer,
        oidc: state.oidc,
    };
}

export default connect(mapStateToProps)(CreateRepackShipments);
